import { useState } from "react";

import ImageModal from "../ImageModal/ImageModal";
import { menuImage } from "../../utils";
import { useSelector } from "react-redux";

const MenuItem = ({ data }) => {
  const setting = useSelector((state) => state.meta?.setting);

  const [isShow, setIsShow] = useState(false);

  const item = { ...data, image: data.image ?? setting.logo };
  return (
    <>
      <div className="col-12 col-sm-8 col-md-6">
        <div
          className="kf-menu-item element-anim-1 scroll-animate"
          data-animate="active"
        >
          <div className="image kf-image-hover">
            <img
              src={menuImage(item.image, setting.logo)}
              alt={item.title}
              onClick={() => setIsShow(true)}
            />
          </div>
          <div className="desc">
            <h6 className="name">{item.title}</h6>
            {item.description && (
              <div className="subname">{item.description}</div>
            )}
            <div className="price">{item.price}</div>
          </div>
        </div>
      </div>

      <ImageModal
        isHeader={false}
        show={isShow}
        onHide={() => setIsShow(false)}
        title={item.title}
      >
        <img
          src={menuImage(item.image, setting.logo)}
          alt={item.title}
          style={{ height: "100%", width: "100%" }}
        />
      </ImageModal>
    </>
  );
};

export default MenuItem;
